// src/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  timeout: 15000, // 15 seconds timeout for slow internet
  headers: { "Content-Type": "application/json" } // default JSON for normal requests
});

export default api;